import React from 'react';
import './Footer.css';

class Footer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <xc-footer
                aria-hidden="true"
                tabIndex="-1"
                client-id="xfinityassistant"
            ></xc-footer>
        );
    }
}

export default Footer;
